import React, { useState, useEffect } from "react";
import { getApiUrl } from "../utils/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchDashboard = async () => {
    setLoading(true);
    try {
      const res = await fetch(getApiUrl("dashboard-api"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      const data = await res.json();
      if (data.success) {
        setDashboardData(data.data);
      } else {
        toast.error("Failed to fetch dashboard data");
      }
    } catch (err) {
      toast.error("Server error! Please try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

  if (loading) {
    return (
      <div className="container py-4 text-center">
        <h2>Loading Dashboard...</h2>
      </div>
    );
  }

  const metrics = [
    { label: "Total Products", value: dashboardData.totalProducts || 0 },
    { label: "Total Sold", value: dashboardData.totalSold || 0 },
    { label: "Remaining Products", value: dashboardData.remainingProducts || 0 },
    { label: "Total Orders", value: dashboardData.totalOrders || 0 },
    { label: "Total Revenue", value: `₹${(dashboardData.totalRevenue || 0).toLocaleString()}` },
    { label: "Shipped Orders", value: dashboardData.shippedOrders || 0 },
    { label: "Unshipped Orders", value: dashboardData.unshippedOrders || 0 },
    { label: "Today Orders", value: dashboardData.todayOrders || 0 },
    { label: "Last 7 Days Orders", value: dashboardData.last7DaysOrders || 0 },
  ];

  return (
    <div className="container py-4">
      <h2 className="mb-4 text-center">Dashboard</h2>

      <div className="row g-4 justify-content-center">
        {metrics.map((metric, index) => (
          <div key={index} className="col-12 col-md-6 col-lg-4 d-flex justify-content-center">
            <div className="dashboard-card shadow-sm p-3 w-100 text-center rounded">
              <h5 className="card-header mb-2">{metric.label}</h5>
              <p className="card-value fs-4 fw-bold">{metric.value}</p>
            </div>
          </div>
        ))}
      </div>

      <ToastContainer />
    </div>
  );
};

export default Dashboard;
